import { Tool } from '@app/shared/utils/enums';
import { PetOwner } from '@app/core/models';
import { createAction, props } from '@ngrx/store';
import { AllowanceParams } from '@app/pages/allowance/allowance';
import { AllowanceNavigationRoutes, ProductSelectionIncentive } from '../allowance.state';
import { SaveConsultationPopinFormValuesOutput } from '@app/shared/components/share-reco-popin/share-reco-popin';

/**
 * Action dispatched to create the consultation.
 * It actually uses an effect to gather information and create the consultation in the consultation store
 */
export const createAllowanceConsultation = createAction('[Allowance] Create Consultation', props<{ owner?: PetOwner; tool?: Tool }>());

export const createAllowanceConsultationFromShareRecoPopin = createAction(
  '[Allowance] Create Consultation from Share Reco Popin',
  props<{ formValues?: SaveConsultationPopinFormValuesOutput }>(),
);

/**
 * Action dispatched to set the allowance params.
 */
export const setAllowanceParams = createAction('[Allowance] Set Allowance Params', props<{ value: AllowanceParams }>());

/**
 * Action dispatched to reset a specific product ID from selectedProductIds.
 */
export const resetAllowanceSelectedProductId = createAction('[Allowance] Reset Selected Product ID', props<{ productId: string }>());

export const setAllowanceNavigationRoutes = createAction(
  '[Allowance] Set Allowance Navigation Routes',
  props<{ allowanceNavigationRoutes: AllowanceNavigationRoutes }>(),
);

export const setProductSelectionIncentive = createAction(
  '[Allowance] Set Product Selection Incentive',
  props<{ productSelectionIncentive: ProductSelectionIncentive }>(),
);

/***
 * convert consultation flow
 */
export const convertAllowanceFlow = createAction('[Allowance] Convert Allowance Flow', props<{ flow: Tool }>());
export const resetAllowanceFlow = createAction('[Allowance] Reset Allowance Flow', props<{ coreTool: Tool }>());
